class PermissionService {
  constructor(user) {
    // view permissions
    this.SettingsViewPermission = 'settings-view';
    this.AssuranceViewPermission = 'assurance';
    this.WebexViewPermission = 'webex';
    this.AnalyticsViewPermission = 'historical2';
    this.HistoricalViewPermission = 'historical';
    this.LyncViewPermission = 'lync';
    this.RoomsViewPermission = 'rooms';
    this.SetupViewPermission = 'setup-view';
    this.AdminPortalPermission = 'adminPortal';

    // element permissions
    this.AlertsManagerPermission = 'alertsManager';
    this.ReportsPermission = 'reportManager';
    this.EndpointEditPermission = 'endpointEdit';
    this.ViewDatasetsPermission = 'viewDatasets';

    // action permissions
    this.AddPanelPermission = 'addPanel';
    this.DashboardEditPermission = 'dashboardEdit';
    this.DashboardCopyPermission = 'dashboardCopy';
    this.DashboardAdminPermissions = 'dashboardAdmin';
    this.RemovePeripheralPermission = 'removePeripheral';

    // user role lists- first line views, second line element, third line actions  todo: maybe make sets?
    const SuperUserPermissions = [
      this.AdminPortalPermission, this.AssuranceViewPermission, this.AnalyticsViewPermission, this.LyncViewPermission, this.RoomsViewPermission, this.SettingsViewPermission, this.SetupViewPermission, this.WebexViewPermission,
      this.AlertsManagerPermission, this.EndpointEditPermission, this.ReportsPermission, this.ViewDatasetsPermission,
      this.AddPanelPermission, this.DashboardEditPermission, this.DashboardCopyPermission, this.DashboardAdminPermissions, this.RemovePeripheralPermission,
    ];
    const AdminPermissions = [
      this.AdminPortalPermission, this.AssuranceViewPermission, this.AnalyticsViewPermission, this.LyncViewPermission, this.RoomsViewPermission, this.SettingsViewPermission, this.SetupViewPermission, this.WebexViewPermission,
      this.AlertsManagerPermission, this.EndpointEditPermission, this.ReportsPermission, this.ViewDatasetsPermission,
      this.AddPanelPermission, this.DashboardEditPermission, this.DashboardCopyPermission, this.RemovePeripheralPermission,
    ];
    const ViewerPermissions = [
      this.AssuranceViewPermission, this.AnalyticsViewPermission, this.LyncViewPermission, this.RoomsViewPermission,
      this.AlertsManagerPermission, this.ReportsPermission, this.ViewDatasetsPermission,
      this.AddPanelPermission, this.DashboardEditPermission,
    ];
    const ReaderPermissions = [
      this.AssuranceViewPermission, this.AnalyticsViewPermission, this.LyncViewPermission, this.RoomsViewPermission,
      this.ViewDatasetsPermission,
    ];
    const DashboardReaderPermissions = [
      this.WebexViewPermission, this.AssuranceViewPermission, this.AnalyticsViewPermission, this.LyncViewPermission, this.RoomsViewPermission,
    ];

    const RoleHierarchy = [DashboardReaderPermissions, ReaderPermissions, ViewerPermissions, AdminPermissions, SuperUserPermissions];
    const RoleMap = {
       'admin': AdminPermissions,
       'su': SuperUserPermissions,
       'pro': AdminPermissions,
       'suPro': SuperUserPermissions,
       'suOrgMgr': AdminPermissions,
       'vanRptVwr': ViewerPermissions,
       'suVwr': ViewerPermissions,
       'vanRptRdr': ReaderPermissions,
       'vanDbVwr': DashboardReaderPermissions,
    };

    this.user = user;
    let highestPermissions = DashboardReaderPermissions;
    if (user && user.roles) {
      user.roles.forEach(function (role) {
        let permissions = RoleMap[role];
        if (RoleHierarchy.indexOf(highestPermissions) < RoleHierarchy.indexOf(permissions)) {
          highestPermissions = permissions;
        }
      });
    }
    this.permissions = highestPermissions;
  }
  hasPermission(permission) {
    if (this.permissions.indexOf(permission) > -1) {
      return true;
    }
    return false;
  }
}

export default PermissionService;
